/*
	日期：2025/08/25
	地点：四川 成都
	作者：终结司令官
	
	介绍：Axios 二次封装
	
	- Powered by finalcommander.com
	- Supported by IOE.TOP
*/

import axios from 'axios'

// 引入全局工具函数
import { globalUtils, constants, defaultConfig } from '../utils/globalUtils'

// Axios 初始化
const http_req = axios.create({
	// 通用请求地址前缀
	baseURL: globalUtils.getBaseUrl(true,false,false,3) + '/open/api',
	// 超时时间
	timeout: 10000,
	
	// `method` 是创建请求时使用的方法
	method: 'get', // default
	// `headers` 是即将被发送的自定义请求头
	headers: {'X-Requested-With': 'XMLHttpRequest'},
	// `responseType` 表示服务器响应的数据类型，可以是 'arraybuffer', 'blob', 'document', 'json', 'text', 'stream'
	responseType: 'json', // default
})

// 添加请求拦截器
http_req.interceptors.request.use(
	function (config) {
		// 在发送请求之前做些什么
		return config;
	},
	function (error) {
		// 对请求错误做些什么
		return Promise.reject(error);
	}
);

// 添加响应拦截器
http_req.interceptors.response.use(
	function (response) {
		// 对响应数据做点什么
		return response;
	}, 
	function (error) {
		// 对响应错误做点什么
		return Promise.reject(error);
	}
);
  
export default http_req